/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  FaUser,
  FaAddressBook,
  FaUsers,
  FaBriefcase,
  FaUpload,
  FaBoxOpen,
  FaEye,
  FaCheck,
} from "react-icons/fa";

// Mirrors ApplyLoans/components/Loan_chip so the hire purchase and loan
// applications read as one flow.
const steps = [
  { id: 1, label: "Personal", icon: FaUser },
  { id: 2, label: "Contact", icon: FaAddressBook },
  { id: 3, label: "Guarantor", icon: FaUsers },
  { id: 4, label: "Employment", icon: FaBriefcase },
  { id: 5, label: "Uploads", icon: FaUpload },
  { id: 6, label: "Items", icon: FaBoxOpen },
  { id: 7, label: "Preview", icon: FaEye },
];

const row1 = steps.slice(0, 4);
const row2 = steps.slice(4);

function StepCircle({ id, label, icon: Icon, formState }) {
  const done = id < formState;
  const active = id === formState;
  return (
    <div className="flex flex-col items-center gap-2 z-10 relative flex-1">
      <div
        className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 border-2 ${
          done
            ? "bg-green-600 border-green-600 text-white shadow-md"
            : active
            ? "bg-white border-green-600 text-green-600 shadow-md"
            : "bg-white border-gray-200 text-gray-400"
        }`}
      >
        {done ? <FaCheck size={16} /> : <Icon size={16} />}
      </div>
      <span
        className={`text-center leading-tight font-semibold uppercase tracking-wide ${
          active ? "text-green-600" : done ? "text-gray-500" : "text-gray-400"
        }`}
        style={{ fontSize: "0.7rem", maxWidth: "4.75rem", wordBreak: "break-word" }}
      >
        {label}
      </span>
    </div>
  );
}

function RowProgress({ rowSteps, formState }) {
  const segments = rowSteps.length - 1;
  const firstId = rowSteps[0].id;
  const filledSegs = Math.min(Math.max(formState - firstId, 0), segments);
  const pct = segments > 0 ? (filledSegs / segments) * 100 : 0;

  return (
    <div className="flex items-start justify-between relative">
      <div
        className="absolute top-[24px] h-0.5 bg-gray-200 z-0"
        style={{ left: "24px", right: "24px" }}
      />
      <div
        className="absolute top-[24px] h-0.5 bg-green-600 z-0 transition-all duration-500"
        style={{ left: "24px", width: `calc(${pct}% * (1 - 48px / 100%))` }}
      />
      {rowSteps.map((step) => (
        <StepCircle key={step.id} {...step} formState={formState} />
      ))}
    </div>
  );
}

function Order_Chips({ formState }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const progress = ((formState - 1) / (steps.length - 1)) * 100;

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "1rem 1rem 1.5rem" }}>
      {isMobile ? (
        /* Three steps per row, so the labels stay legible on a phone. */
        <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
          <RowProgress rowSteps={row1} formState={formState} />
          <RowProgress rowSteps={row2} formState={formState} />
        </div>
      ) : (
        <div className="flex items-start justify-between relative">
          <div
            className="absolute top-[24px] h-0.5 bg-gray-200 z-0"
            style={{ left: "24px", right: "24px" }}
          />
          <div
            className="absolute top-[24px] h-0.5 bg-green-600 z-0 transition-all duration-500"
            style={{ left: "24px", width: `calc(${progress}% * (1 - 48px / 100%))` }}
          />
          {steps.map((step) => (
            <StepCircle key={step.id} {...step} formState={formState} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Order_Chips;
